import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

export const getRateTableCellStyles = ({
  isSelected,
  isApplicable,
  isInitLoanOptionId,
  isNewLoanOptionId,
}) => ({
  position: 'relative',
  height: 74,
  borderColor: ({ palette }) => `${palette.border.default} !important`,

  '&.MuiTableCell-root': {
    fontWeight: ({ typography }) => {
      return isSelected || isNewLoanOptionId || isInitLoanOptionId || isApplicable
        ? typography.fontWeightMedium
        : typography.fontWeightRegular;
    },

    color: ({ palette }) => {
      if (isSelected || isNewLoanOptionId) {
        return COLOR_PALETTE.BRAND[6];
      }

      if (isApplicable) {
        return palette.text.primary;
      }

      return palette.text.placeholder;
    },

    ...getConditionalObject(isInitLoanOptionId || isNewLoanOptionId, {
      '&::after': {
        content: '""',
        position: 'absolute',
        right: 0,
        top: 0,
        left: 0,
        bottom: 0,
        border: '1px solid',
        borderColor: COLOR_PALETTE.ADDITIONAL[2],
      },
    }),

    backgroundColor: ({ palette }) => {
      if (isSelected || isNewLoanOptionId) {
        return COLOR_PALETTE.BRAND[1];
      }

      if (isInitLoanOptionId) {
        return 'initial';
      }

      if (isApplicable) {
        return palette.background.secondary;
      }

      return 'initial';
    },

    '&:hover': {
      cursor: isApplicable && !isSelected ? 'pointer' : 'default',
    },
  },
});
